import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-200">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                  <i className="ri-vip-crown-line text-secondary-900 text-lg"></i>
                </div>
                <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                  太子千秋万载
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                专注中国古代皇储祝颂文化研究，传承中华礼制文明的深厚底蕴。为您深度解析千秋万载的历史渊源与文化内涵。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/category/lishi-yuanyuan"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    历史渊源
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/liyi-changjing"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    礼仪场景
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/wenhua-neihan"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    文化内涵
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/yingshi-xiqu"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    影视戏曲
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                关于本站
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                热门标签
              </h4>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 text-xs rounded-full bg-secondary-800 text-background-300">
                  太子千秋万载
                </span>
                <span className="px-3 py-1 text-xs rounded-full bg-secondary-800 text-background-300">
                  储君文化
                </span>
                <span className="px-3 py-1 text-xs rounded-full bg-secondary-800 text-background-300">
                  皇太子祝颂
                </span>
                <span className="px-3 py-1 text-xs rounded-full bg-secondary-800 text-background-300">
                  礼制传统
                </span>
                <span className="px-3 py-1 text-xs rounded-full bg-secondary-800 text-background-300">
                  千秋节
                </span>
                <span className="px-3 py-1 text-xs rounded-full bg-secondary-800 text-background-300">
                  皇室礼仪
                </span>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 太子千秋万载文化研究. All rights reserved.
            </p>
            <p className="text-xs text-background-500">
              传承中华礼制文化 弘扬传统人文精神
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}